import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const cuisineTypePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  isErrorProne: PropTypes.bool.isRequired,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
  isExcludedFromBrowsing: PropTypes.bool,
  node: nodePropType.isRequired,
})

cuisineTypePropType.defaultProps = {
  description: undefined,
  isExcludedFromSearch: false,
  isExcludedFromBrowsing: false,
}

export default cuisineTypePropType
